import { callable } from './callable'

export type HelperNotifyViaMode = 'BOTH' | 'APP_ONLY' | 'WHATSAPP_ONLY'

export type SetHelperNotifyViaPayload = {
  workspaceId: string
  uid?: string
  notifyVia: HelperNotifyViaMode
}

export type SetHelperNotifyViaResponse = {
  ok: boolean
  notifyVia: HelperNotifyViaMode
}

export const setHelperNotifyVia = async (
  input: SetHelperNotifyViaPayload,
): Promise<SetHelperNotifyViaResponse> => {
  return callable('setHelperNotifyVia', input)
}
